
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import draggable from 'vuedraggable';
import { DataTableHeader } from 'vuetify';
import { BaseProfileDataInterface } from '@/services/Users-profile/interfaces';
import { EventsInterface, EventType } from '@/services/Calendar/Events/Interfaces';
import DeleteEventDialog from '@/components/dialogs/calendar/events/DeleteEventDialog.vue';

@Component({
  computed: {
    EventType() {
      return EventType
    }
  },
  mixins: [
    Themeable,
  ],
  components: {
    draggable,
    DeleteEventDialog: DeleteEventDialog,
  },
  inject: [
    'nationalEventsRepository',
    'profileRepository',
  ],
})
export default class EventsComponent extends Vue {
  @Prop() private events!: EventsInterface[];
  @Prop() private usersMap!: { [userId: string]: BaseProfileDataInterface };

  private headers: DataTableHeader[] = [
    { text: 'Name', value: 'name' },
    { text: 'Date', value: 'date' },
    { text: 'Type', value: 'type' },
    { text: 'Author', value: 'author' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];
  private deleteEventDialogData: EventsInterface | false = false;
  private deleteEventDialog: string = '';
  private months: string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  private search: string = '';

  private createEvent(): void {
    this.$router.push({ name: 'calendar_crate_event' });
  }

  private editEvent(event: EventsInterface): void {
    this.$router.push({ name: 'calendar_edit_event', params: { eventId: String(event.id) } });
  }

  private deleteEvent(event: EventsInterface): void {
    this.deleteEventDialog = 'delete-event-dialog';
    this.deleteEventDialogData = event;
  }

  private viewAllAttendants(event: EventsInterface): void {
    this.$router.push({ name: 'calendar_event_attendant', params: { eventId: String(event.id) } });
  }

  private filterEvents(id: number): void {
    this.$emit('filter-events', id);
  }
}
